import { RootState } from 'rootReducer';

export const settingsGlobSelector = (state: RootState) => state.adiminModuleReducer.settingsGlobalReducer;
